import { css, Theme } from "@emotion/react"

export const shopFooterStyle = (theme: Theme) => css`
	${theme.breakpoints.down("sm")} {
		margin-left: 0;
	}
`
